// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_gr-0";
export var actionModalContentContainer = "_gr-1";
export var createTagButton = "_gr-2";
export var footerContainer = "_gr-7";
export var fullWidthDivider = "_gr-3";
export var hasCreateTagButton = "_gr-4";
export var noCreateTagButton = "_gr-5";
export var tagsContainer = "_gr-6";
export var tagsModalContentContainer = "_gr-8";